
/**
 * First, we will load all of this project's Javascript utilities and other
 * dependencies. Then, we will be ready to develop a robust and powerful
 * application frontend using useful Laravel and JavaScript libraries.
 */

import './bootstrap';
import './plugins';

import { createApp } from 'vue';
import {createBootstrap,
    BCol,
    BCollapse,
    BContainer,
    BRow,
    BButton,
    BFormCheckbox,
    BFormRadioGroup,
    BFormGroup,
    BFormSelect,
    BTab,
    BTable,
    BTabs,
    BTooltip,
    BCard,
    BCardBody,
    BCardHeader,
    BPagination,
    BFormCheckboxGroup,
    BFormInput,
    BInput,
    BInputGroup,
    BTh,
    BTr,
    BLink,
    BPopover,
    BFormDatalist,
  } from 'bootstrap-vue-next';
import { createPinia } from 'pinia';
import VueApexCharts from 'vue3-apexcharts'

// Add the necessary CSS
// bootstrap.css gets pulled in separately so can skip that here. 
// import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';

import PollsApp from './components/PollsApp.vue';
import TotalsApp from './components/TotalsApp.vue';
import TotalsHistorical from './components/totals/TotalsHistorical.vue';
import TotalsProjections from './components/totals/TotalsProjections.vue';

import { useEventStore } from './stores/events';
import { useToplinesStore } from './stores/toplines';

// Setup data store
const pinia = createPinia();

// Vue.use(VCalendar);

const pollsApp = createApp({});
pollsApp.use(createBootstrap());
pollsApp.use(pinia);

const totalsApp = createApp({});
totalsApp.use(createBootstrap());
totalsApp.use(pinia);
totalsApp.use(VueApexCharts);

const totalsHistorical= createApp({});
totalsHistorical.use(createBootstrap());
totalsHistorical.use(pinia)
totalsHistorical.use(VueApexCharts);

const totalsProjections = createApp({});
totalsProjections.use(createBootstrap());
totalsProjections.use(pinia)
totalsProjections.use(VueApexCharts);

// Use pinia for the event store
window.eventSubscriptions = {};
window.CCLEvent= useEventStore();

// Create the toplines store
window.ccl.toplinesStore = useToplinesStore();

// Gives you
// CCLEvent.emit
// CCLEvent.$subscribe

pollsApp.component('polls-app', PollsApp);

pollsApp.component('BCard', BCard);
pollsApp.component('BCardBody', BCardBody);
pollsApp.component('BCardHeader', BCardHeader);
pollsApp.component('BCol', BCol);
pollsApp.component('BCollapse', BCollapse);
pollsApp.component('BContainer', BContainer);
pollsApp.component('BButton',BButton);
pollsApp.component('BFormCheckbox',BFormCheckbox);
pollsApp.component('BFormCheckboxGroup',BFormCheckboxGroup);
pollsApp.component('BFormDataList',BFormDatalist);
pollsApp.component('BFormGroup',BFormGroup);
pollsApp.component('BFormInput',BFormInput);
pollsApp.component('BFormRadioGroup',BFormRadioGroup);
pollsApp.component("BFormSelect", BFormSelect);
pollsApp.component('BInput',BInput);
pollsApp.component('BInputGroup',BInputGroup);
pollsApp.component('BLink',BLink);
pollsApp.component('BPagination',BPagination);
pollsApp.component('BPopover',BPopover);
pollsApp.component('BRow', BRow);
pollsApp.component('BTab',BTab);
pollsApp.component('BTable',BTable);
pollsApp.component('BTabs',BTabs);
pollsApp.component('BTooltip',BTooltip);
pollsApp.component('BTh',BTh);
pollsApp.component('BTr',BTr);

pollsApp.directive('BPopover',BPopover);

pollsApp.mount('#polls-app-container');

totalsApp.component('totals-app', TotalsApp);
totalsApp.component('BCard', BCard);
totalsApp.component('BCardBody',BCardBody);
totalsApp.component('BCardHeader',BCardHeader);
totalsApp.component('BCol', BCol);
totalsApp.component('BContainer', BContainer);
totalsApp.component('BRow', BRow);
totalsApp.component('BTable',BTable);
totalsApp.mount('#totals-app-container')

totalsHistorical.component('totals-historical', TotalsHistorical);
totalsHistorical.component('BCard', BCard);
totalsHistorical.component('BCardBody',BCardBody);
totalsHistorical.component('BCardHeader',BCardHeader);
totalsHistorical.component('BContainer', BContainer);
totalsHistorical.component('BFormSelect', BFormSelect);
totalsHistorical.component('BTable',BTable);
totalsHistorical.mount('#totals-historical-container');

totalsProjections.component('totals-projections', TotalsProjections);
totalsProjections.component('BCard', BCard);
totalsProjections.component('BCardBody',BCardBody);
totalsProjections.component('BCardHeader',BCardHeader);
totalsProjections.component('BContainer', BContainer);
totalsProjections.component('BTable',BTable);
totalsProjections.mount('#totals-projections-container');


/*
// Add the Vue components for API authentication
Vue.component(
    'passport-clients',
    require('./components/passport/Clients.vue')
);

Vue.component(
    'passport-authorized-clients',
    require('./components/passport/AuthorizedClients.vue')
);

Vue.component(
    'passport-personal-access-tokens',
    require('./components/passport/PersonalAccessTokens.vue')
);
});*/